module.exports = __webpack_public_path__ + "img/Washing.ea67b991.png";